var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbout2Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E4912C",
    fillOpacity: 0,
    fillRule: "evenodd",
    d: "M0 0h15v15H0V0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#222",
    fillRule: "evenodd",
    d: "M12.732 5.179L11.321 7.22c-.093.133-.245.213-.411.213H7.153v4.662c0 .269-.22.487-.495.487-.273 0-.495-.218-.495-.487V7.433H1.49c-.273 0-.496-.218-.496-.487V2.863c0-.269.223-.487.496-.487h4.673v-.68c0-.27.222-.488.495-.488.275 0 .495.218.495.488v.68h3.757c.166 0 .318.079.411.213l1.411 2.041c.116.166.116.383 0 .549zm-2.083-1.828H1.985v3.107h8.664l1.077-1.553-1.077-1.554z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbout2Icon);
export default __webpack_public_path__ + "static/media/about-2-icon.4dce6f39ed3e3427c408d66ce65ea265.svg";
export { ForwardRef as ReactComponent };